import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../../store/auth-context";
import { Box, Button, Card, CardContent, Container, Grid, Typography } from '@mui/material';
// Service
import { get, post } from "../../../services/FetchHelper";
// Utils
import {
    InitialChangePasswordState,
    ChangePasswordSchema,
    ChangePasswordFormFields,
} from "./PasswordChange.utils";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import { StyledDrawerForm } from "../../../configs/GoStyles";
import Iconify from "../../../components/iconify/Iconify";
import EntityConstants from "../../../configs/EntityConstants";
import RouteConstants from "../../../configs/RouteConstants";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const PasswordChange = ({ open, handleClose }) => {
    const [formFields, setFormFields] = useState(ChangePasswordFormFields);

    const handleSubmit = async (values) => {
        if (values.password !== values.confirm_password) {
            toast.error("New and confirm password not matched...");
        } else {
            try {
                const response = await post(EntityConstants.PASSWORD_CHANGE, {
                    password: values,
                });
                if ([200, 201].indexOf(response.status) > -1) {
                    toast.success("Password changed...");
                    handleClose(false);
                }
            } catch (error) {
                toast.error("Failed to update...");
            }
        }
    };

    return (
        <Dialog open={open} onClose={() => handleClose(false)}>

            <Formik
                enableReinitialize
                initialValues={InitialChangePasswordState}
                validationSchema={ChangePasswordSchema}
                onSubmit={(values) => handleSubmit(values)}
            >
                {({
                    values,
                    touched,
                    errors,
                    dirty,
                    isSubmitting,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <DialogTitle>Change Password</DialogTitle>
                        <DialogContent>
                            <StyledDrawerForm>
                                <Grid
                                    container
                                    maxWidth="sm"
                                    rowSpacing={1}
                                    columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                                >
                                    {formFields.map((formField, index) => {
                                        return (
                                            <Grid key={index} item xs={12} sm={12} md={12} lg={12}>
                                                <GoForm
                                                    config={formField}
                                                    values={values}
                                                    touched={touched}
                                                    errors={errors}
                                                    handleChange={handleChange}
                                                />
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            </StyledDrawerForm>
                        </DialogContent>
                        <DialogActions>
                            <Button color="error" variant="contained" onClick={() => handleClose(false)}>Cancel</Button>
                            <Button variant="contained" disabled={isSubmitting} type="submit">Change Password</Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>

        </Dialog>
    )
};

export default PasswordChange;